export default {
  dialogTitle: "批量加入看板",
  tradingBoard: {
    title: "交易資料看板",
    info: "加入後可在交易資料裡查看",
  },
  balanceBoard: {
    title: "餘額資料看板",
    info: "加入後可在餘額資料裡查看",
  },
  addBoth: {
    title: "同時加入",
    info: "同時加入餘額看板和交易看板",
  },
};
